import { makeActionCreator } from "../../utils";

export const ERRORS_CHANGED = "REPORTS.VALIDATION.ERRORS_CHANGED";
export const ERROR_CLEARED = "REPORTS.VALIDATION.ERROR_CLEARED";

export const errorsChanged = makeActionCreator(ERRORS_CHANGED, "payload");
export const errorCleared = makeActionCreator(ERROR_CLEARED, "payload");
